import React, { createContext } from "react";
import { Updater } from "use-immer";

export interface SearchOption {
  group: string;
  render: () => React.ReactNode;
  select: () => void;
}

export interface CmdKState {
  input?: string;
  highlighted?: number;
  secondaryAction?: boolean;
}

export interface CmdKContextType {
  state: CmdKState;
  options: SearchOption[];
  setState: Updater<CmdKState>;
  setInput: (input: string) => void;
  select: (idx?: number) => void;
  close: (track?: boolean) => void;
}

export const CmdKContext = createContext<CmdKContextType>({
  state: {},
  options: [],
  setState: () => {},
  setInput: () => {},
  select: (idx?: number) => {},
  close: (track?: boolean) => {},
});
